import React from 'react';
import { InvoiceDisplayStatus } from '../../types/invoice';
import { statusLabel } from '../../utils/invoiceFormatting';

function getStatusBadgeColor(status: InvoiceDisplayStatus): string {
  switch (status) {
    case 'paid':
      return 'bg-green-100 text-green-800';
    case 'open':
      return 'bg-blue-100 text-blue-800';
    case 'pending payment':
      return 'bg-sky-100 text-sky-800';
    case 'draft':
      return 'bg-surface-container-low text-on-surface';
    case 'overdue':
      return 'bg-amber-100 text-amber-900';
    case 'void':
      return 'bg-red-100 text-red-800';
    case 'blocked':
      return 'bg-orange-100 text-orange-900';
    case 'mixed':
      return 'bg-slate-200 text-slate-800';
    default:
      return 'bg-surface-container-low text-on-surface';
  }
}

type Props = {
  status: InvoiceDisplayStatus;
};

export default function InvoiceStatusBadge({ status }: Props) {
  return (
    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeColor(status)}`}>
      {statusLabel(status)}
    </span>
  );
}
